let teams = [
    {
        name: 'Subhan Janura',
        division: 'Head Leader Seulanga',
        role: 'leader',
        imgUrl: '/img/subhan.png',
    },
    {
        name: 'Nur Ridho Rizky',
        division: 'Web & Mobile Development',
        role: 'leader',
        imgUrl: '/img/ridho.png',
    },
    {
        name: 'Nuzul Hikam',
        division: 'Cyber Security',
        role: 'leader',
        imgUrl: '/img/nuzul.png',
    },
    {
        name: 'Muhammad Hafez Al-Assad',
        division: 'Embedded System & IoT',
        role: 'leader',
        imgUrl: '/img/hafez.png',
    },
];

export default teams;